import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BackToTopButton, StyledTextH3 } from './styles';
import { mixins } from '../../settings';

class BackToTop extends Component {
  static propTypes = {
    children: PropTypes.string
  };

  static defaultProps = {
    children: 'Back to Top'
  };

  render() {
    const { children } = this.props;

    return (
      <BackToTopButton>
        <button onClick={mixins.scrollTop}>
          <StyledTextH3 align="center" transform="uppercase">
            {children}
          </StyledTextH3>
        </button>
      </BackToTopButton>
    );
  }
}

export default BackToTop;
